import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import { Icon } from '@iconify/react';
import { Tooltip } from '@biq/apex-ui';
import { themeObject } from 'lib';

interface CustomIconButtonProps {
    title: string;
    icon: string;
    onClick: () => void;
    className?: string;
}

const styles = {
    icon: { color: themeObject.palette.grayScale[500] },
    iconHovered: { color: themeObject.palette.primary[500] },
};

export const CustomIconButton = ({
    title,
    icon,
    onClick,
    className,
}: CustomIconButtonProps): React.JSX.Element => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Tooltip title={title} arrow placement='top'>
            <IconButton
                onClick={onClick}
                onMouseEnter={(): void => setIsHovered(true)}
                onMouseLeave={(): void => setIsHovered(false)}
                style={isHovered ? styles.iconHovered : styles.icon}
            >
                <Icon className={className} icon={icon} />
            </IconButton>
        </Tooltip>
    );
};
